import { APP_NAME } from "@/config/constants";
import { useTranslation } from "@/hooks/useTranslation";
import { useEffect, useRef } from "react";

declare global {
  namespace JSX {
    interface IntrinsicElements {
      "pwa-install": {
        "manifest-url"?: string;
        name?: string;
        description?: string;
        icon?: string;
        ref?: React.RefObject<HTMLElement>;
      };
    }
  }
}

export const PwaInstall = () => {
  const { t } = useTranslation();
  const pwaRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (pwaRef.current) {
      const description = t("home.hero.heading");
      if (typeof description === "string") {
        pwaRef.current.setAttribute("description", description);
      }
    }
  }, []);
  return (
    <>
      <pwa-install ref={pwaRef} manifest-url="/manifest.json" name={APP_NAME} icon="/favicon.svg" />
    </>
  );
};
